import React, { Component } from "react";
import Button from "../../../../../components/common/button/Button";
import styles from "./CompanyProfile.scss";
import Input from "../../../../../components/common/input/Input";
import Select2 from "../../../../../components/common/select/Select2";
import Textarea from "../../../../../components/common/textarea/Textarea";
import { Form, FormGroup } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import {
  required,
  alphaNumericSpace,
  dropdown,
  maxLength
} from "../../../../../utils/forms/validators";
import { connect } from "react-redux";
import { load as loadCompanyProfile } from "../../../../../actions/companyProfile.actions";
import Typeahead from "../../../../../components/common/typeahead/Typeahead";
import ScrollToTopOnMount from "../../../../../utils/scroll/ScrollToTopOnMount";

import { COMPANY_PROFILE_FORM } from "../../../../../actions/company.actions";

export const alphaNumericSpaceValidation = msg => alphaNumericSpace(msg);
export const dropdownValidation = msg => dropdown(msg);
export const maxLengthValidation = (max, msg) => maxLength(max, msg);

export const location = alphaNumericSpaceValidation(
  "Please enter a valid Location."
);
export const industry = dropdownValidation("Please select an Industry.");
export const companySize = dropdownValidation("Please select a Company Size.");
export const summary = maxLengthValidation(
  280,
  "Summary must be less than or equal to 280 characters."
);
export const isURL = input => {
  let match = input.match(/[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}/g);
  return match == null ? "Please enter a valid website url." : undefined;
};

class CompanyProfile extends Component {
  render() {
    const {
      submitting,
      valid,
      industries,
      companySizes,
      onSearchCities,
      isLoading,
      cities
    } = this.props;

    return (
      <section className={styles.companyProfile}>
        <ScrollToTopOnMount />
        <div className={styles.secondHeader}>
          Your account has been created. Please provide the following
          information about your company to create a Project.
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>Create Your Company Profile</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.subheading}>
                  Your profile will help members viewing your project learn more
                  about you.
                </div>
              </FormGroup>
              <FormGroup>
                <Field
                  name="industry_id"
                  type="select"
                  placeholder="Industry"
                  component={Select2}
                  options={industries}
                  validate={industry}
                />

                <Field
                  name="company_size_id"
                  type="select"
                  placeholder="Company Size"
                  component={Select2}
                  options={companySizes}
                  validate={companySize}
                />

                <Field
                  name="location"
                  placeholder="Location"
                  component={Typeahead}
                  isLoading={isLoading || false}
                  options={cities}
                  isAsync={true}
                  minLength={3}
                  allowNew={false}
                  labelKey="description"
                  valueKey="id"
                  validate={required}
                  icon="map-marker"
                  focusOut={selected => {
                    if (!selected) {
                      this.props.change("location", null);
                    }
                  }}
                  onSearch={query => onSearchCities(query)}
                />

                <Field
                  name="url"
                  type="text"
                  placeholder="Website or LinkedIn Page"
                  component={Input}
                  validate={[required, isURL]}
                />

                <Field
                  name="summary"
                  type="textarea"
                  placeholder="Describe your company to prospective
                  freelancers and employees (you can edit this later)."
                  component={Textarea}
                  help={"Please enter a brief description of your company."}
                  maxlength={280}
                  label="Company Summary"
                  validate={[required, summary]}
                />

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Continue"
                  isDisabled={!valid || submitting}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

CompanyProfile = reduxForm({
  form: COMPANY_PROFILE_FORM,
  enableReinitialize: true,
  touchOnChange: true
})(CompanyProfile);

CompanyProfile = connect(
  state => {
    return {
      initialValues: state.companyProfile.data
    };
  },
  dispatch => ({
    load: data => dispatch(loadCompanyProfile(data))
  })
)(CompanyProfile);

export default CompanyProfile;



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/components/CompanyProfile/CompanyProfile.js